import Vue from 'vue';
import Router from 'vue-router';
import config from './assets/js/conf/config';
import request from './assets/js/utils/request';

Vue.use(Router);
let ucmenu = []
function getUCmenu(){
	request.post(config.baseApi + "/supplier/System.Supplierrole/getMenu").then((res)=>{
		if(res.status == 200){
			localStorage["ucmenu"]=JSON.stringify(res.data)
		}
	})
}

let router = new Router({
	mode: "history", //1、hash哈希：有#号。2、history历史：没有#号
	base: process.env.BASE_URL, //自动获取根目录路径
	scrollBehavior: (to, from, position) => {
		if (position) {
			return position
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [{
			path: "/",
			name: "login",
			component: () => import("./pages/login"),
			meta:{isHome:true}
		},
		{
			path: "/register",
			name: "register",
			component: () => import("./pages/register"),
			meta:{isHome:true}
		},
		{
			path: "/ucenter",
			name: "ucenter",
			component: () => import("./pages/ucenter"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_address",
			name: "uc_address",
			component: () => import("./pages/uc_address"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_shop",
			name: "uc_shop",
			component: () => import("./pages/uc_shop"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_logistics",
			name: "uc_logistics",
			component: () => import("./pages/uc_logistics"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_goods",
			name: "uc_goods",
			component: () => import("./pages/uc_goods"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_shelves",
			name: "uc_shelves",
			component: () => import("./pages/uc_shelves"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_stalls",
			name: "uc_stalls",
			component: () => import("./pages/uc_stalls"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_goods_edit",
			name: "uc_goods_edit",
			component: () => import("./pages/uc_goods/edit"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order",
			name: "ucenter order",
			component: () => import("./pages/uc_order"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_deliver",
			name: "ucenter order deliver",
			component: () => import("./pages/uc_order/deliver"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_detail",
			name: "ucenter order detail",
			component: () => import("./pages/uc_order/detail"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_order_detail_saled",
			name: "ucenter order detail saled",
			component: () => import("./pages/uc_order/saled"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_wallet",
			name: "ucenter wallet",
			component: () => import("./pages/uc_wallet"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_setting",
			name: "ucenter setting",
			component: () => import("./pages/uc_setting"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_extend",
			name: "ucenter extend",
			component: () => import("./pages/uc_extend"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_position",
			name: "ucenter position manage",
			component: () => import("./pages/uc_position"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_employee",
			name: "ucenter employee manage",
			component: () => import("./pages/uc_employee"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/uc_pwd",
			name: "ucenter set Password",
			component: () => import("./pages/uc_pwd"),
			meta:{auth:true,authority:true}
		},
		{
			path: "/notice",
			name: "notice center",
			component: () => import("./pages/notice")
		},
	]
});
router.beforeEach((to, from, next) => {
	ucmenu = localStorage['ucmenu'] ? JSON.parse(localStorage['ucmenu']) :[]
	if(localStorage['auth'] && ucmenu && ucmenu.length == 0){
		getUCmenu()
		return false
	}
	if(!to.name){//路径错误跳转，可替换404页面
		next("/");
	}
	if (to.meta.auth) {
		if (localStorage['auth']) {//需要登录验证且已登录
			if(to.meta.authority){
				let item = ucmenu.find(item => {
					return item.url == "."+to.path;
				});
				let isChild = strLink("."+to.path)
				// console.log('_______________',item,isChild)
				if(item || isChild){//有进入该页面的权限
					next()
				}else{//没有该页面的权限，但通过其他方式进入
					alert('权限不足！')
					next(ucmenu[0].url +'?menuId='+ucmenu[0].menu_id)
				}
			}else{
				next();
			}
		} else {//需要登录验证但未登录
			next("/");
		}
	} else if(to.meta.isHome) {
		if (localStorage['auth']) {
			next(ucmenu[0].url +'?menuId='+ucmenu[0].menu_id);
		} else {
			next();
		}
	} else {
		next();
	}
});
function strLink(str){
	ucmenu = localStorage['ucmenu'] ? JSON.parse(localStorage['ucmenu']) :[]
	let c = ""
	for(let i in ucmenu){
		if(str.indexOf(ucmenu[i].url) != -1){
			c = str.replace(ucmenu[i].url,"")
			break;
		}
	}
	return Boolean(c)
}
export default router;
